var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "downArrowIcon_3_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 497",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h40v25H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "downArrowIcon_3_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 496",
    fill: "none",
    d: "M0 0h40v25H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Arrow",
    clipPath: "url(#downArrowIcon_3_svg__a)",
    transform: "rotate(90 13 13)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Arrow"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 499",
    fill: "#040000",
    clipPath: "url(#downArrowIcon_3_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 862",
    d: "M39.558 12.158L29.618.215a.593.593 0 00-1.049.38v23.884a.593.593 0 001.049.379l9.941-11.943a.593.593 0 000-.758"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 494",
    d: "M.302 7.313h28.684V17.76H.302z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon3);
export default __webpack_public_path__ + "static/media/downArrowIcon_3.9b506bf6c6d64e9b.svg";
export { ForwardRef as ReactComponent };